import PropTypes from 'prop-types';
import {Enums} from '_app/utils';

const languages = Enums.getType('languages');
const trackTypes = Enums.getType('trackTypes');

export default PropTypes.shape({
	id: PropTypes.number.isRequired,
	mediaID: PropTypes.number.isRequired,
	version: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	keyText: PropTypes.string.isRequired,
	Language: PropTypes.oneOf([
		languages.ENGLISH,
		languages.SPANISH
	]).isRequired,
	type: PropTypes.oneOf([
		trackTypes.SUBTITLE,
		trackTypes.CAPTION
	]).isRequired,
	deleteDate: PropTypes.string,
});